import { Injectable } from '@angular/core';
import { HttpService } from '../../utils/services/http.service';
import { Observable } from 'rxjs/Observable';
import { SessionStorage } from 'ngx-webstorage';
import { ErrorsService } from '../../utils/services/errors.service';

@Injectable()
export class TimesheetApprovalsService {
  @SessionStorage() public user;
  public selectedrow: any;
  constructor(private httpService: HttpService,
    private errorsService: ErrorsService) { }
  
  /**function to set selected row data */
  public setSelectedRowData(data, weekNumber, year) {
    this.selectedrow = { 'data': data, 'weekNumber': weekNumber, 'year' : year };
  }

  /**function to get selected row data */
  public getSelectedRowData() {
    return this.selectedrow;
  }

  /**API to employee timesheet approval*/
  getrmTimesheetApprovals(weeknumber, year): Observable<any> {
    const data = {
      'userDetails': {
        'Empno': this.user.Empno,
        'role': 'RM'
      },
      'weeknumber': Number(weeknumber),
      'year' : Number(year),
      'pageNumber': 1,
      'pageSize': 2000
    };
    return this.httpService.post(`timesheet/rm/view`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /**API to approve timesheet*/
  rmTimesheetApprove(weeknumber, data, year): Observable<any> {
    const datesToAppove = [];
    if (data.dateDetails) {
      data.dateDetails.forEach(element => {
        const obj = Object.assign({}, element);
        if (obj.approvalStatus.status != 2) {
          delete obj.approvalStatus;
          delete obj.createdDate;
          delete obj.leaveType;
          delete obj.__v;
          delete obj._id;
          datesToAppove.push(obj);
        }
      });
    }
    const dataParam = {
      'weeknumber': Number(weeknumber),
      'empno': data.employeenumber,
      'datesToAppove': datesToAppove,
      'rmcode': this.user.Empno,
      'year': year
    };

    return this.httpService.post(`timesheet/approval`, dataParam)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /**function to reject timesheet*/
  rmTimesheetReject(weeknumber, year, empnum, rejectionComment): Observable<any> {
    const data = {
      'weeknumber': Number(weeknumber),
      'year' : year,
      'empno': empnum,
      'comment': rejectionComment
    };
    return this.httpService.post(`timesheet/reject`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /**API to approve all timesheet*/
  rmTimesheetApproveAll(data): Observable<any> {
    return this.httpService.post(`timesheet/approval`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }


  /**API to get temp data*/  
  getTempCleanupdata() {
    return this.httpService.get(`temp`)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /**Function to handle error*/  
  handleError(error: any) {
    this.errorsService.handleError(error);
    return Observable.throw(error.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/rm/timesheet-approvals/timesheet-approvals.service.ts